import classNames from "classnames";

export const bindStyle = (styleSheet: any) => classNames.bind(styleSheet);
